/* eslint-disable import/first */
import React from 'react';
import { Grid, IconButton } from '@material-ui/core';
import BackArrow from '../Icons/BackArrow';
import CloseIcon from '../Icons/CloseIcon';
import css from './index.module.scss';
import ClassNames from 'classnames';
function PHBackButton({ onclick, classname, cross = false } = {}) {
  return (
    <Grid className={ClassNames(classname, css.root)}>
      <IconButton onClick={onclick}>{cross ? <CloseIcon /> : <BackArrow />}</IconButton>
    </Grid>
  );
}

export default PHBackButton;
